






import Swiper from 'swiper';
import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: 'Projects',
})
export default class Projects extends Vue {
  mounted() {
    const container = this.$el.querySelector<HTMLElement>('.swiper-container');
    if (!container) {
      return;
    }

    new Swiper(container, {
      slidesPerView: 1.5,
      keyboard: {
        enabled: true,
      },
      centeredSlides: false,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
      },
      breakpoints: {
        576: {
          slidesPerView: 2.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
      },
    });
  }
}
